// extracted by mini-css-extract-plugin
export var container = "index-module--container--bE3Sq";
export var h4 = "index-module--h4--P0vzk";
export var moreButton = "index-module--moreButton--aaIGc";
export var p1 = "index-module--p1--Hg7wY";